import { useEffect } from 'react';
import { useWorker } from 'shared/domains/workers';
const workerInstance = new Worker(new URL('./hast.worker', import.meta.url));
/**
 * Function to take a HTML template, placeholder values and condition values and return the final HTML content
 * @param html HTML Template source input
 * @param values Placeholder values and condition values
 * @param keys Keys from decision-tree in composer, optional if contract HTML should be sectionized
 * @returns Contract HTML content
 */
export function useCompileHTMLTemplate(html, values, keys) {
    const [postMessage, state] = useWorker(workerInstance);
    const valuesJson = JSON.stringify(values);
    useEffect(() => {
        postMessage({ html, values: JSON.parse(valuesJson), keys });
    }, [html, valuesJson, postMessage, keys]);
    return state;
}
